/** alerts: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "preset_offline": "A player is offline for 10 min",
  "preset_black": "Black screen for 5 min",
  "preset_sync": "Out of sync for 30 min",
  "preset_storage": "Storage below 10 %",
  "preset_critical": "Any critical Health Check issue",
  "metric_offline_minutes": "Offline time",
  "metric_out_of_sync_minutes": "Out of sync time",
  "metric_fallback_minutes": "Fallback (black screen) time",
  "metric_files_failed": "Failed files",
  "metric_errors_last_hour": "Errors in the last hour",
  "metric_storage_free_percent": "Free storage",
  "metric_memory_free_mb": "Free memory",
  "metric_battery_percent": "Battery level",
  "metric_health_issue": "Health Check issue open",
  "metricDesc_offline_minutes": "Minutes since the player last checked in.",
  "metricDesc_out_of_sync_minutes": "Minutes a newer published revision has been waiting to play.",
  "metricDesc_fallback_minutes": "Minutes the player has been showing its fallback instead of your content.",
  "metricDesc_files_failed": "Files the player could not download or verify.",
  "metricDesc_errors_last_hour": "Error lines in the player log during the last hour.",
  "metricDesc_storage_free_percent": "Free space on the player.",
  "metricDesc_memory_free_mb": "Memory the system has available.",
  "metricDesc_battery_percent": "Players with a battery only.",
  "metricDesc_health_issue": "A Health Check issue of the chosen kind and severity is open on the player.",
  "unit_min": "min",
  "unit_files": "files",
  "unit_errors": "errors",
  "unit_%": "%",
  "unit_MB": "MB",
  "op_gte": "at least",
  "op_gt": "more than",
  "op_eq": "equal to",
  "op_neq": "not equal to",
  "op_lt": "less than",
  "op_lte": "at most",
  "listSep": ", ",
  "and": " and ",
  "or": " or ",
  "nPlayers": "{n} player | {n} players",
  "nGroups": "{n} group | {n} groups",
  "groupX": "group {names}",
  "taggedX": "tagged {tag}",
  "allPlayers": "All players",
  "allExcept": "All players except {parts}",
  "playersX": "Players: {parts}",
  "quoted": "“{v}”",
  "anyIssue": "Any Health Check issue",
  "sevCritical": " (critical)",
  "sevWarning": " (warning or worse)",
  "issueOpen": "{what} is open {for}",
  "forMin": "for {n} min",
  "anyTimeIn": "at any time in the last {n} min",
  "overMin": "over {n} min",
  "condIs": "{label} is {value}",
  "condIsWhen": "{label} is {value} {when}",
  "condAvg": "{label} averages {value} {when}",
  "windowRange": "The window is 1–{max} minutes.",
  "checkEmails": "Check the email address: {list} | Check the email addresses: {list}",
  "emailStatus": "Email {status}.",
  "hookFailed": "Webhook failed: {note}.",
  "unknownError": "unknown error",
  "savedX": "Saved “{name}”",
  "savedRecheck": "Saved “{name}”. It is checked again within a minute",
  "createdX": "Created “{name}”. It is checked every minute",
  "checkedMinute": "{hint} Players are checked once a minute.",
  "inScope": "({n} player) | ({n} players)",
  "notEmail": "Not an email address: {list}",
  "wouldFire": "Would fire for {n} of {total} player | Would fire for {n} of {total} players",
  "wouldNot": "Wouldn’t fire for any of {total} player | Wouldn’t fire for any of {total} players",
  "noData": "{n} player has no data for this. | {n} players have no data for this.",
  "historyNote": "“{kind}” uses the last {n} minutes; players only have that history once an alert covers them.",
  "allAdmins": "all admins",
  "emailWho": "Email {who}",
  "perPlayerShort": "one message per player",
  "perCheckShort": "one message per check",
  "isOn": "“{name}” is on",
  "isOff": "“{name}” is off; its open incidents were closed",
  "copySuffix": "{name} (copy)",
  "duplicated": "Duplicated as “{name}” (off until you turn it on)",
  "deleteQ": "Delete the alert “{name}” and its incident history?",
  "deletedX": "Deleted “{name}”",
  "dSent": "Sent",
  "dSkipped": "Skipped",
  "dFailed": "Failed",
  "firingN": "Firing · {n} player | Firing · {n} players",
  "lastTriggered": "Last triggered {when}",
  "switchAria": "{name}: {state}",
  "onLower": "on",
  "offLower": "off",
  "incidentsOf": "Incidents · {name}",
  "valueX": "· value {v}",
  "emailD": "✉️ Email {s}",
  "hookD": "↗ Webhook {s}",
  "enterThreshold": "Enter a threshold.",
  "checkForm": "Check the form.",
  "testSent": "Test email sent.",
  "hookDelivered": "Webhook delivered.",
  "secretCopied": "Signing secret copied",
  "leaveQ": "You have unsaved changes. Leave without saving?",
  "atAnyTime": "At any time",
  "atAnyTimeHint": "Fires as soon as one check meets it.",
  "throughout": "Throughout",
  "throughoutHint": "Every check in the window must meet it.",
  "onAverage": "On average",
  "onAverageHint": "The mean over the window.",
  "backToAlerts": "Back to Alerts",
  "newAlert": "New Alert",
  "unsaved": "Unsaved",
  "cancel": "Cancel",
  "saving": "Saving…",
  "save": "Save",
  "createAlert": "Create Alert",
  "loading": "Loading…",
  "step1": "1. When",
  "whatToWatch": "What to watch",
  "problem": "Problem",
  "anyProblem": "Any problem",
  "severity": "Severity",
  "criticalOnly": "Critical only",
  "warnOrCrit": "Warning or critical",
  "anySeverity": "Any severity",
  "is": "Is",
  "threshold": "Threshold",
  "howLong": "How long",
  "condition": "Condition",
  "inTheLast": "in the last",
  "windowMin": "Window in minutes",
  "min": "min",
  "ignoreEmpty": "Ignore players with no data",
  "ignoreEmptyHint": "e.g. a player that has never connected, or has no battery. Untick to alert on them too.",
  "firesWhen": "Fires when:",
  "step2": "2. Which players",
  "playersMatching": "Players matching",
  "match": "Match",
  "any": "any",
  "all": "all",
  "none": "none",
  "filtersBelow": "of the filters below. No filters = every player.",
  "players": "Players",
  "playerGroups": "Player groups",
  "noGroups": "No player groups yet.",
  "playerTags": "Player tags",
  "tagsHint": "(each tag is one filter; a group’s tags count for its players)",
  "appliesTo": "Applies to:",
  "step3": "3. Notify",
  "emailAdmins": "Email all organization admins",
  "alsoEmail": "Also email",
  "messages": "Messages",
  "perCheck": "One message per check, listing the players",
  "perCheckHint": "Best when many players can fail together (a network outage).",
  "perPlayer": "One message per player",
  "perPlayerHint": "Up to 50 per check; the rest arrive in one summary.",
  "remindEvery": "Remind me every",
  "remindHint": "min while it’s still firing (0 = don’t remind)",
  "onClear": "Also tell me when it clears",
  "webhook": "Webhook",
  "webhookOpt": "(optional, https)",
  "signedWith": "A JSON POST, signed with",
  "hmac": "(HMAC of the body).",
  "signingSecret": "Signing secret:",
  "copy": "Copy",
  "secretLater": "The signing secret appears here after you create the alert.",
  "nobody": "Nobody will be notified: incidents are only listed on the Alerts page.",
  "sending": "Sending…",
  "sendTest": "Send a test",
  "name": "Name",
  "alertName": "Alert name",
  "nameHint": "Used in the list and as the email subject. Leave blank to use the condition.",
  "on": "On",
  "rightNow": "Right now",
  "checking": "Checking…",
  "title": "Alerts",
  "intro": "Get an email or a webhook when players go offline, show a black screen, run out of storage, and more. Checked every minute.",
  "weeklyTitle": "Email me a weekly Health Check summary",
  "weeklyHint": "Mondays at 08:00 your time: open issues, players offline, and the alerts that fired. Just for you; each member chooses.",
  "retry": "Retry",
  "colAlert": "Alert",
  "colStatus": "Status",
  "actions": "Actions",
  "ok": "OK",
  "off": "Off",
  "neverTriggered": "Never triggered",
  "incidents": "Incidents",
  "edit": "Edit",
  "duplicate": "Duplicate",
  "delete": "Delete",
  "noAlerts": "No alerts yet",
  "emptyHint": "Health Check lists every problem. Alerts tell you about the ones that matter, as soon as they happen.",
  "askAdmin": "Ask an admin to set one up.",
  "incidentsDesc": "One incident per player, from when the alert triggered until it cleared. The last 200.",
  "show": "Show",
  "firingNow": "Firing now",
  "allShort": "All",
  "firing": "Firing",
  "cleared": "Cleared",
  "nothingFiring": "Nothing is firing.",
  "notTriggered": "This alert hasn’t triggered yet.",
  "weeklyOff": "Weekly Health Check email turned off",
  "weeklyOn": "You’ll get the Health Check summary on Mondays at 08:00 (your time)",
  "noNotification": "No notification (incidents only)"
};
const ar: typeof en = {
  "preset_offline": "مشغل غير متصل لمدة ١٠ دقائق",
  "preset_black": "شاشة سوداء لمدة ٥ دقائق",
  "preset_sync": "غير متزامن لمدة ٣٠ دقيقة",
  "preset_storage": "التخزين أقل من ١٠٪",
  "preset_critical": "أي مشكلة حرجة في فحص الحالة",
  "metric_offline_minutes": "مدة عدم الاتصال",
  "metric_out_of_sync_minutes": "مدة عدم التزامن",
  "metric_fallback_minutes": "مدة الشاشة الاحتياطية (السوداء)",
  "metric_files_failed": "الملفات الفاشلة",
  "metric_errors_last_hour": "الأخطاء في الساعة الأخيرة",
  "metric_storage_free_percent": "التخزين المتاح",
  "metric_memory_free_mb": "الذاكرة المتاحة",
  "metric_battery_percent": "مستوى البطارية",
  "metric_health_issue": "مشكلة مفتوحة في فحص الحالة",
  "metricDesc_offline_minutes": "الدقائق منذ آخر اتصال للمشغل.",
  "metricDesc_out_of_sync_minutes": "الدقائق التي انتظرتها نسخة منشورة أحدث قبل عرضها.",
  "metricDesc_fallback_minutes": "الدقائق التي عرض فيها المشغل شاشته الاحتياطية بدل محتواك.",
  "metricDesc_files_failed": "الملفات التي لم يتمكن المشغل من تنزيلها أو التحقق منها.",
  "metricDesc_errors_last_hour": "أسطر الأخطاء في سجل المشغل خلال الساعة الأخيرة.",
  "metricDesc_storage_free_percent": "المساحة المتاحة على المشغل.",
  "metricDesc_memory_free_mb": "الذاكرة المتاحة للنظام.",
  "metricDesc_battery_percent": "المشغلات ذات البطارية فقط.",
  "metricDesc_health_issue": "مشكلة فحص حالة من النوع والخطورة المختارين مفتوحة على المشغل.",
  "unit_min": "دقيقة",
  "unit_files": "ملفات",
  "unit_errors": "أخطاء",
  "unit_%": "٪",
  "unit_MB": "ميغابايت",
  "op_gte": "على الأقل",
  "op_gt": "أكثر من",
  "op_eq": "يساوي",
  "op_neq": "لا يساوي",
  "op_lt": "أقل من",
  "op_lte": "على الأكثر",
  "listSep": "، ",
  "and": " و",
  "or": " أو ",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "nGroups": "لا مجموعات | مجموعة واحدة | مجموعتان | {n} مجموعات | {n} مجموعة | {n} مجموعة",
  "groupX": "المجموعة {names}",
  "taggedX": "الموسومة {tag}",
  "allPlayers": "كل المشغلات",
  "allExcept": "كل المشغلات باستثناء {parts}",
  "playersX": "المشغلات: {parts}",
  "quoted": "«{v}»",
  "anyIssue": "أي مشكلة في فحص الحالة",
  "sevCritical": " (حرجة)",
  "sevWarning": " (تحذير أو أسوأ)",
  "issueOpen": "{what} مفتوحة {for}",
  "forMin": "لمدة {n} دقيقة",
  "anyTimeIn": "في أي وقت خلال آخر {n} دقيقة",
  "overMin": "على مدى {n} دقيقة",
  "condIs": "{label} {value}",
  "condIsWhen": "{label} {value} {when}",
  "condAvg": "متوسط {label} {value} {when}",
  "windowRange": "النافذة من ١ إلى {max} دقيقة.",
  "checkEmails": "تحقق من عنوان البريد: {list} | تحقق من عنوان البريد: {list} | تحقق من عنواني البريد: {list} | تحقق من عناوين البريد: {list} | تحقق من عناوين البريد: {list} | تحقق من عناوين البريد: {list}",
  "emailStatus": "البريد: {status}.",
  "hookFailed": "فشل الـ Webhook: {note}.",
  "unknownError": "خطأ غير معروف",
  "savedX": "تم حفظ «{name}»",
  "savedRecheck": "تم حفظ «{name}». سيُفحص مجددًا خلال دقيقة",
  "createdX": "تم إنشاء «{name}». يُفحص كل دقيقة",
  "checkedMinute": "{hint} تُفحص المشغلات مرة كل دقيقة.",
  "inScope": "(لا مشغلات) | (مشغل واحد) | (مشغلان) | ({n} مشغلات) | ({n} مشغلًا) | ({n} مشغل)",
  "notEmail": "ليس عنوان بريد إلكتروني: {list}",
  "wouldFire": "سيُطلق لـ {n} من {total} مشغل | سيُطلق لـ {n} من {total} مشغل | سيُطلق لـ {n} من {total} مشغل | سيُطلق لـ {n} من {total} مشغلات | سيُطلق لـ {n} من {total} مشغلًا | سيُطلق لـ {n} من {total} مشغل",
  "wouldNot": "لن يُطلق لأي مشغل | لن يُطلق للمشغل الوحيد | لن يُطلق لأيٍّ من المشغلَين | لن يُطلق لأيٍّ من {total} مشغلات | لن يُطلق لأيٍّ من {total} مشغلًا | لن يُطلق لأيٍّ من {total} مشغل",
  "noData": "لا مشغلات بلا بيانات. | مشغل واحد لا بيانات لديه لهذا. | مشغلان لا بيانات لديهما لهذا. | {n} مشغلات لا بيانات لديها لهذا. | {n} مشغلًا لا بيانات لديها لهذا. | {n} مشغل لا بيانات لديها لهذا.",
  "historyNote": "يستخدم «{kind}» آخر {n} دقيقة؛ ولا يتوفر هذا السجل للمشغلات إلا بعد أن يشملها تنبيه.",
  "allAdmins": "كل المسؤولين",
  "emailWho": "بريد إلى {who}",
  "perPlayerShort": "رسالة لكل مشغل",
  "perCheckShort": "رسالة لكل فحص",
  "isOn": "«{name}» مفعّل",
  "isOff": "«{name}» متوقف؛ أُغلقت حوادثه المفتوحة",
  "copySuffix": "{name} (نسخة)",
  "duplicated": "تم التكرار باسم «{name}» (متوقف حتى تفعّله)",
  "deleteQ": "حذف التنبيه «{name}» وسجل حوادثه؟",
  "deletedX": "تم حذف «{name}»",
  "dSent": "أُرسل",
  "dSkipped": "تم التخطي",
  "dFailed": "فشل",
  "firingN": "مُطلق · لا مشغلات | مُطلق · مشغل واحد | مُطلق · مشغلان | مُطلق · {n} مشغلات | مُطلق · {n} مشغلًا | مُطلق · {n} مشغل",
  "lastTriggered": "آخر إطلاق {when}",
  "switchAria": "{name}: {state}",
  "onLower": "مفعّل",
  "offLower": "متوقف",
  "incidentsOf": "الحوادث · {name}",
  "valueX": "· القيمة {v}",
  "emailD": "✉️ البريد: {s}",
  "hookD": "↗ الـ Webhook: {s}",
  "enterThreshold": "أدخل حدًّا.",
  "checkForm": "تحقق من النموذج.",
  "testSent": "تم إرسال بريد الاختبار.",
  "hookDelivered": "تم تسليم الـ Webhook.",
  "secretCopied": "تم نسخ سر التوقيع",
  "leaveQ": "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
  "atAnyTime": "في أي وقت",
  "atAnyTimeHint": "يُطلق بمجرد أن يستوفيه فحص واحد.",
  "throughout": "طوال الفترة",
  "throughoutHint": "يجب أن يستوفيه كل فحص في النافذة.",
  "onAverage": "في المتوسط",
  "onAverageHint": "المتوسط على مدى النافذة.",
  "backToAlerts": "العودة إلى التنبيهات",
  "newAlert": "تنبيه جديد",
  "unsaved": "غير محفوظ",
  "cancel": "إلغاء",
  "saving": "جارٍ الحفظ…",
  "save": "حفظ",
  "createAlert": "إنشاء تنبيه",
  "loading": "جارٍ التحميل…",
  "step1": "١. متى",
  "whatToWatch": "ما يُراقب",
  "problem": "المشكلة",
  "anyProblem": "أي مشكلة",
  "severity": "الخطورة",
  "criticalOnly": "الحرجة فقط",
  "warnOrCrit": "تحذير أو حرجة",
  "anySeverity": "أي خطورة",
  "is": "القيمة",
  "threshold": "الحد",
  "howLong": "المدة",
  "condition": "الشرط",
  "inTheLast": "خلال آخر",
  "windowMin": "النافذة بالدقائق",
  "min": "دقيقة",
  "ignoreEmpty": "تجاهل المشغلات التي لا بيانات لها",
  "ignoreEmptyHint": "مثل مشغل لم يتصل قط، أو بلا بطارية. ألغِ التحديد للتنبيه عليها أيضًا.",
  "firesWhen": "يُطلق عندما:",
  "step2": "٢. أي المشغلات",
  "playersMatching": "المشغلات المطابقة لـ",
  "match": "المطابقة",
  "any": "أيٍّ",
  "all": "كل",
  "none": "لا شيء",
  "filtersBelow": "من المرشحات أدناه. بلا مرشحات = كل المشغلات.",
  "players": "المشغلات",
  "playerGroups": "مجموعات المشغلات",
  "noGroups": "لا توجد مجموعات مشغلات بعد.",
  "playerTags": "وسوم المشغلات",
  "tagsHint": "(كل وسم مرشح واحد؛ وسوم المجموعة تُحسب لمشغلاتها)",
  "appliesTo": "ينطبق على:",
  "step3": "٣. الإشعار",
  "emailAdmins": "إرسال بريد إلى كل مسؤولي المؤسسة",
  "alsoEmail": "إرسال بريد أيضًا إلى",
  "messages": "الرسائل",
  "perCheck": "رسالة واحدة لكل فحص تسرد المشغلات",
  "perCheckHint": "الأفضل عندما قد تتعطل مشغلات كثيرة معًا (انقطاع الشبكة).",
  "perPlayer": "رسالة واحدة لكل مشغل",
  "perPlayerHint": "حتى ٥٠ لكل فحص؛ ويصل الباقي في ملخص واحد.",
  "remindEvery": "ذكّرني كل",
  "remindHint": "دقيقة ما دام مستمرًا (٠ = بلا تذكير)",
  "onClear": "أخبرني أيضًا عند زواله",
  "webhook": "Webhook",
  "webhookOpt": "(اختياري، https)",
  "signedWith": "طلب JSON POST موقّع بـ",
  "hmac": "(HMAC لمحتوى الطلب).",
  "signingSecret": "سر التوقيع:",
  "copy": "نسخ",
  "secretLater": "يظهر سر التوقيع هنا بعد إنشاء التنبيه.",
  "nobody": "لن يُبلَّغ أحد: تُدرج الحوادث في صفحة التنبيهات فقط.",
  "sending": "جارٍ الإرسال…",
  "sendTest": "إرسال اختبار",
  "name": "الاسم",
  "alertName": "اسم التنبيه",
  "nameHint": "يُستخدم في القائمة وكعنوان للبريد. اتركه فارغًا لاستخدام الشرط.",
  "on": "مفعّل",
  "rightNow": "الآن",
  "checking": "جارٍ الفحص…",
  "title": "التنبيهات",
  "intro": "احصل على بريد أو Webhook عندما تنقطع المشغلات أو تعرض شاشة سوداء أو تنفد مساحتها، وغير ذلك. يُفحص كل دقيقة.",
  "weeklyTitle": "أرسل لي ملخصًا أسبوعيًا لفحص الحالة",
  "weeklyHint": "أيام الاثنين الساعة ٠٨:٠٠ بتوقيتك: المشكلات المفتوحة والمشغلات غير المتصلة والتنبيهات التي أُطلقت. لك وحدك؛ يختار كل عضو.",
  "retry": "إعادة المحاولة",
  "colAlert": "التنبيه",
  "colStatus": "الحالة",
  "actions": "الإجراءات",
  "ok": "سليم",
  "off": "متوقف",
  "neverTriggered": "لم يُطلق قط",
  "incidents": "الحوادث",
  "edit": "تعديل",
  "duplicate": "تكرار",
  "delete": "حذف",
  "noAlerts": "لا توجد تنبيهات بعد",
  "emptyHint": "يسرد فحص الحالة كل مشكلة. وتخبرك التنبيهات بالمهم منها فور حدوثه.",
  "askAdmin": "اطلب من مسؤول إعداد تنبيه.",
  "incidentsDesc": "حادثة واحدة لكل مشغل، من إطلاق التنبيه حتى زواله. آخر ٢٠٠.",
  "show": "عرض",
  "firingNow": "مُطلق الآن",
  "allShort": "الكل",
  "firing": "مُطلق",
  "cleared": "زال",
  "nothingFiring": "لا شيء مُطلق.",
  "notTriggered": "لم يُطلق هذا التنبيه بعد.",
  "weeklyOff": "تم إيقاف بريد فحص الحالة الأسبوعي",
  "weeklyOn": "ستصلك خلاصة فحص الحالة أيام الاثنين الساعة ٠٨:٠٠ (بتوقيتك)",
  "noNotification": "بلا إشعار (الحوادث فقط)"
};
export default { en, ar };
